import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Hero2.css";

const Hero2 = () => {
  return (
    <>
      {/* SEO Meta Tags + Local Business Structured Data */}
      <Helmet>
        <title>Best Doctors in Indapur | Compassionate Healthcare | Dr. Chavan Multi-Speciality Hospital</title>

        <meta
          name="description"
          content="Dr. Chavan Multi-Speciality Hospital offers access to the best doctors in Indapur, providing advanced care in Surgery, Laparoscopy, Endoscopy, and Gynaecology with modern technology and compassionate treatment."
        />

        <meta
          name="keywords"
          content="best doctors in Indapur, Indapur hospital, multi-speciality hospital, surgery experts Indapur, laparoscopy specialist Indapur, gynaecologist Indapur, advanced medical care Indapur"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Best Doctors in Indapur | Dr. Chavan Multi-Speciality Hospital" />
        <meta
          property="og:description"
          content="Meet the best doctors in Indapur at Dr. Chavan Multi-Speciality Hospital — specialists in Surgery, Endoscopy, Laparoscopy, and Gynaecology offering advanced healthcare."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://drchavanhospital.in/" />
        <meta property="og:image" content="https://drchavanhospital.in/images/hero2.jpeg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Best Doctors in Indapur | Dr. Chavan Multi-Speciality Hospital" />
        <meta
          name="twitter:description"
          content="Advanced and compassionate healthcare with the best doctors in Indapur offering surgery, laparoscopy, endoscopy, and women’s health services."
        />
        <meta name="twitter:image" content="https://drchavanhospital.in/images/hero2.jpeg" />

        {/* Local Business Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Dr. Chavan Multi-Speciality Hospital",
              "image": "https://drchavanhospital.in/images/hero2.jpeg",
              "url": "https://drchavanhospital.in/",
              "telephone": "+91-XXXXXXXXXX",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Your Street Address",
                "addressLocality": "Indapur",
                "addressRegion": "Maharashtra",
                "postalCode": "413106",
                "addressCountry": "IN"
              },
              "medicalSpecialty": [
                "Surgery",
                "Gynaecology",
                "Laparoscopy",
                "Endoscopy"
              ],
              "description": "Dr. Chavan Multi-Speciality Hospital provides advanced treatments with the best doctors in Indapur specializing in surgery, endoscopy, laparoscopy and women's care."
            }
          `}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="hero2" role="banner" aria-label="Hero Section - Best Doctors in Indapur | Dr. Chavan Multi-Speciality Hospital">
        <div className="hero2-container">
          {/* Left Column */}
          <div className="hero2-content">
            <h2
              className="hero2-subtitle"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Welcome to <strong>Dr. Chavan Multi-Speciality Hospital</strong>
            </h2>

            <h1
              className="hero2-title"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Compassionate Care,  
              <span className="highlight">Advanced Medical Excellence</span>
            </h1>

            <p
              className="hero2-description"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Our hospital is home to some of the <strong>best doctors in Indapur</strong>, providing
              expert care in <strong>Surgery</strong>, <strong>Laparoscopy</strong>, <strong>Endoscopy</strong>, and
              <strong> Gynaecology</strong>. With modern facilities and a patient-centered approach, we ensure
              safe, accurate, and compassionate treatment for every patient.
            </p>

            <div
              className="hero2-buttons"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <Link
                to="/contact"
                className="btn-primaryy"
                aria-label="Book an Appointment at Dr. Chavan Multi-Speciality Hospital Indapur"
              >
                Book an Appointment
              </Link>

              <Link
                to="/about"
                className="btn-secondaryy"
                aria-label="Learn more about Dr. Chavan Multi-Speciality Hospital Indapur"
              >
                Learn More
              </Link>
            </div>
          </div>

          {/* Right Column */}
          <div
            className="hero2-image"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <img
              src="./images/hero2.webp"
              alt="Best Doctors in Indapur - Dr. Chavan Multi-Speciality Hospital"
              className="hero2-img"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero2;
